/*******************************************************************************
WATCH DATA FILTER INPUT
Watch for keystrokes inside the data filter text input box.
*******************************************************************************/

import clearFilter from './clear';

export default function watchItemFilterInput(e) {
    const $filterInput = $(e.currentTarget);
    const searchTerm = $filterInput.val();
    const $filterWrapper = $filterInput.parents('.filter');

    // The CSS selector that determines what an "item" is
    const itemSelector = $filterInput.data('items');
    const $items = $(itemSelector);

    // This optional attribute is used if the content that needs to be searched is something specific inside the item
    // Ex. If you want to filter table rows, but you only want to filter the results based on the first column's content
    const subset = $filterInput.data('subset') || '';

    // This is the name that's used in the "No [items name] found" empty state message. Defaults to "matches".
    const itemsName = $filterInput.data('item') || 'matches';

    // Build the clear button
    const $clearButton = $('<div />', { class: 'filter-clear' }).text('Clear');

    // Build the "no matches found" indicator
    const $noMatchesIndicator = $('<div />', { class: 'filter-empty' }).text(`No ${itemsName} found.`);

    // Remove the previous "no matches found" indicator (if applicable)
    $('.filter-empty').remove();

    // Add the clear button if it doesn't exist
    $filterWrapper.find('.filter-clear').doIfNotExists(() => { $filterWrapper.append($clearButton); });

    // If the input is empty (or the ESC key is pressed, then get rid of the clear button and show everything
    if (!searchTerm || e.which === 27) {
        $filterInput.val('');
        $filterWrapper.find('.filter-clear').remove();
        $items.removeClass('hide-filter');
        return;
    }

    // If the search string does not match part of the search term, hide the item. Otherwise show it.
    $items.each(function filterItems() {
        const $item = $(this);

        // If there's an optional subset, use that when the searching the item
        const $itemToSearch = (subset) ? $item.find(subset).text() : $item.text();

        // Filter the items
        if ($itemToSearch.search(new RegExp(searchTerm, 'i')) < 0) {
            $item.addClass('hide-filter');
        }
        else {
            $item.removeClass('hide-filter');
        }
    });

    // If there no matching items, display the message explaining that
    if ($(`${itemSelector}:not(.hide-filter)`).length === 0) {
        $filterWrapper.after($noMatchesIndicator);

        // Adjust the left padding to fit the input position
        const noMatchesLeftPad = parseInt($filterWrapper.css('padding-left'), 10) + parseInt($noMatchesIndicator.css('padding-left'), 10);
        $noMatchesIndicator.css('padding-left', `${noMatchesLeftPad}px`);
    }

    // If you press enter when there's only one item displaying (and it's a link), then go to the link
    // Or if there's a button, trigger a click on it (and also clear the filter)
    if (e.which === 13) {
        if ($(itemSelector).not('.hide-filter').find('a').length === 1) {
            window.location.href = $(`${itemSelector}:visible`).find('a').attr('href');
            return;
        }
        if ($(itemSelector).not('.hide-filter').find('button:visible').length === 1) {
            $(`${itemSelector}:visible`).find('button').trigger('click');
            clearFilter(itemSelector);
        }
    }
}
